import appStyles from "@App/app.module.scss";

const lockBody = () => {
  document?.body?.classList?.add(appStyles.bodyLocked);
  const html = document?.getElementsByTagName("html");
  html?.[0]?.classList.add(appStyles.bodyLocked);
};

export default lockBody;
